"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadFile = exports.remove = exports.patch = exports.put = exports.post = exports.get = void 0;
const utils_1 = require("./utils");
const config_1 = require("./config");
/**
 * Does a GET request to the given url, with the query params if
 * they are provided. Then gives the result to the configured middleware
 * for processing.
 *
 * @example
 * ```js
 *  get('/api/pokemon', { page: 1 }).then((json) => {
 *   // Do something with the json here
 *  });
 * ```
 * @export
 * @param {string} url The url you want to send a GET request to.
 * @param {QueryParams} queryParams Optional query params as an object.
 * @returns {Promise} Returns a Promise, the content of the promise depends on the configured middleware.
 */
function get(url, queryParams) {
    return __awaiter(this, void 0, void 0, function* () {
        const finalUrl = (0, utils_1.buildUrl)(url, queryParams);
        return (0, config_1.getApi)()
            .get(finalUrl)
            .then((res) => res.data);
    });
}
exports.get = get;
/**
 * Does a POST request to the given url, with the given payload.
 * Then gives the result to the configured middleware
 * for processing.
 *
 * @example
 * ```js
 *  post('/api/pokemon', { name: "bulbasaur" }).then((json) => {
 *    // Do something with the json here
 *  });
 * ```
 *
 * @export
 * @param {string} url The url you want to send a POST request to.
 * @param {Payload} payload The payload you want to send to the server.
 * @returns {Promise} Returns a Promise, the content of the promise depends on the configured middleware.
 */
function post(url, payload) {
    return (0, config_1.getApi)()
        .post(url, payload)
        .then((res) => res.data);
}
exports.post = post;
/**
 * Does a PUT request to the given url, with the given payload.
 * Then gives the result to the configured middleware
 * for processing.
 *
 * @example
 * ```js
 *  put('/api/pokemon/1', { id: 1, name: "bulbasaur" }).then((json) => {
 *    // Do something with the json here
 *  });
 * ```
 *
 * @export
 * @param {string} url The url you want to send a PUT request to.
 * @param {Payload} payload The payload you want to send to the server.
 * @returns {Promise} Returns a Promise, the content of the promise depends on the configured middleware.
 */
function put(url, payload) {
    return (0, config_1.getApi)()
        .put(url, payload)
        .then((res) => res.data);
}
exports.put = put;
/**
 * Does a PATCH request to the given url, with the given payload.
 * Then gives the result to the configured middleware
 * for processing.
 *
 * @example
 * ```js
 *  patch('/api/pokemon/1', { id: 1, name: "bulbasaur" }).then((json) => {
 *    // Do something with the json here
 *  });;
 * ```
 *
 * @export
 * @param {string} url  The url you want to send a PATCH request to.
 * @param {Payload} payload The payload you want to send to the server.
 * @returns {Promise} Returns a Promise, the content of the promise depends on the configured middleware.
 */
function patch(url, payload) {
    return (0, config_1.getApi)()
        .patch(url, payload)
        .then((res) => res.data);
}
exports.patch = patch;
/**
 * Does a DELETE request to the given url.
 * Then gives the result to the configured middleware
 * for processing.
 *
 * Note: this function is called 'remove' and not 'delete' because
 * delete is a keyword in JavaScript.
 *
 * @example
 * ```js
 *  remove('/api/pokemon/1').then(() => {
 *    // Do something here.
 *  });;
 * ```
 *
 * @export
 * @param {string} url  The url you want to send a DELETE request to.
 * @returns {Promise} Returns a Promise, the content of the promise depends on the configured middleware.
 */
function remove(url) {
    return (0, config_1.getApi)()
        .delete(url)
        .then((res) => res.data);
}
exports.remove = remove;
/**
 * Does a GET request to the given url, with the query params if
 * they are provided. Then causes the result file to be sent to
 * the browser as download.
 *
 * @example
 * ```js
 *  downloadFile('/api/pokemon/pdf', { sort: 'id,asc' });
 * ```
 * @export
 * @param {string} url The url you want to send a GET request to.
 * @param {QueryParams} queryParams Optional query params as an object.
 * @returns {Promise} Returns a Promise, the content of the promise depends on the configured middleware.
 */
function downloadFile(url, queryParams) {
    return __awaiter(this, void 0, void 0, function* () {
        const finalUrl = (0, utils_1.buildUrl)(url, queryParams);
        const response = yield (0, config_1.getApi)().get(finalUrl, {
            responseType: 'blob'
        });
        const content = response.headers['content-disposition'];
        if (!content) {
            return;
        }
        const filename = content.split('filename=')[1].replace(/['"]+/g, '');
        const link = document.createElement('a');
        const href = URL.createObjectURL(response.data);
        link.href = href;
        link.setAttribute('download', filename);
        link.click();
        link.remove();
        URL.revokeObjectURL(href);
    });
}
exports.downloadFile = downloadFile;
